import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../redux/actions/index';
import { validateLoginForm } from '../../../Utility/validator/formValidation';
import { formInputTextErrorStyle, routes } from 'Utility/constants';
import Loader from 'react-loader-spinner';

const Login = (props) => {
   let dispatch = useDispatch();

   let isLoading = useSelector((state) => state.authReducer.isLoading);
   const [visible, setVisible] = useState(false)

   const initialFormValues = {
      email: '',
      password: '',
   };

   const handleVisible = () => {
      setVisible(!visible)
   }

   return (
      <div id="wrap">
         <div className="wrap-login100">
            <Formik
               // enableReinitialize={true}
               initialValues={initialFormValues}
               onSubmit={(values) => {
                  let email = values.email.trim().toLowerCase();
                  values.email = email.toLowerCase();
                  dispatch(actions.login({ user: { ...values } }));
               }}
               validate={(values) => validateLoginForm(values)}
            >
               {(formik_props) => {
                  return (
                     <Form className="login100-form validate-form">
                        <span className="login100-form-title">Login</span>
                        <fieldset className="form_fields">
                           <div className="form-group">
                              {/* <!-- <label className="label_modify">Email</label> --> */}
                              <Field
                                 className="input_modify text-lowercase"
                                 type="text"
                                 name="email"
                                 placeholder="Email"
                              />
                              <ErrorMessage
                                 name="email"
                                 render={(msg) => (
                                    <span style={formInputTextErrorStyle}>
                                       {msg}
                                    </span>
                                 )}
                              />
                           </div>
                           <div className="form-group" style={{ position: "relative" }}>
                              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                                 <Field
                                    className="input_modify"
                                    type={visible ? "text" : "password"}
                                    name="password"
                                    placeholder="Password"
                                    style={{ paddingRight: "38px", width: "100%" }}
                                 />
                                 <span
                                    style={{
                                       position: 'absolute',
                                       top: '50%',
                                       right: '10px',
                                       transform: 'translateY(-50%)',
                                       cursor: 'pointer',
                                       zIndex: 2,
                                       display: 'flex',
                                       alignItems: 'center',
                                       height: '100%',
                                    }}
                                    onClick={handleVisible}
                                    title={visible ? "Hide Password" : "Show Password"}
                                 >
                                    {!visible ? (
                                       <i className="fa fa-eye-slash" aria-hidden="true"></i>
                                    ) : (
                                       <i className="fa fa-eye" aria-hidden="true"></i>
                                    )}
                                 </span>
                              </div>
                              <ErrorMessage
                                 name="password"
                                 render={(msg) => (
                                    <span style={formInputTextErrorStyle}>
                                       {msg}
                                    </span>
                                 )}
                              />
                           </div>
                        </fieldset>

                        <div className="form-group text-center">
                           <button
                              disabled={isLoading ? true : false}
                              type="submit"
                              className="theme_btn theme_primary btn-block"
                           >
                              {isLoading ? (
                                 <Loader
                                    type="Circles"
                                    color="#FFF"
                                    height={25}
                                    width={80}
                                 />
                              ) : (
                                 'Sign In'
                              )}
                           </button>
                        </div>
                        <div className="ihweb_flex_btwn_Vc">
                           <a
                              href="javascript:void(0)"
                              className="form_link"
                              onClick={() =>
                                 props.history.push(routes.FORGOTPASSWORD)
                              }
                           >
                              Forgot Password
                           </a>
                           <a
                              href="javascript:void(0)"
                              onClick={() =>
                                 props.history.push(routes.REGISTER)
                              }
                              className="form_link"
                           >
                              Sign Up
                           </a>
                        </div>
                     </Form>
                  );
               }}
            </Formik>
         </div>
      </div>
   );
};

export default withRouter(Login);
